<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	import {
		formatDate
	} from '@/utils/date'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
	  title: null,
	  url: null,
	  toUser: [],
	  desc: null,
	  
	  template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				flowId:null,
				formLoading: false,
				listLoading: false,
				sendMessageData: Object.assign({},sendMessagetTemplate)
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.flowId = this.$route.query.flowId;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			
			clickChoose(dataVal, name) {
				
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values=[];
						dataVal.Values.push([depart.id,depart.name]);
						dataVal.Value = depart.name;
						
					}
				})
			},

			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var that = this;
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					await that.getEmployeeRelation();
					controls.TemplateContent.Controls.forEach((item) => {
						var departs = that.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "区域董事") {
							item.Values = that.findEmpByPositionName(that.relationList, "区域董事");
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门直属主管") {
							item.Values = that.findEmpByPositionName(that.relationList, "主管");
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门总监总经理") {

							item.Values = that.findEmpByPositionName(that.relationList, "总监");
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values = that.findEmpByPositionName(that.relationList, "总经理");
							}
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大区董事") {
							item.Values = that.findEmpByPositionName(that.relationList, "高级大区董事", 7);
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大区总经理") {
							item.Values = that.findEmpByPositionName(that.relationList, "总经理", 8);
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "所在部门") {
							if (departs.indexOf("房友圈") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "房友圈"})[0].Key;
							}  
							else if (departs.indexOf("住宅行政支持组") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "住宅行政支持组"})[0].Key;
							}
							else if (departs.indexOf("住宅部") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "住宅部"})[0].Key;
							}  
							else if (departs.indexOf("二级市场营运中心") > -1||departs.indexOf("代理")>-1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "二级市场营运中心/代理"})[0].Key;
							}
							else if (departs.indexOf("工商铺商业运营中心") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "工商铺商业运营中心"})[0].Key;
							}
							else if (departs.indexOf("非营业部") > -1) {
								item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "非营业部"})[0].Key;
							}
							item.Disable=true;
							item.IsShow=false;			
						}
						if (item.Property.Title[0].Text == "小计") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "合计") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "填表日期") {
							let date = new Date();
							item.Value = formatDate(date,"yyyy-MM-dd");
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请项目内容合计") {
							item.IsShow = false;
						}
					});
					that.templateData = that.assignControl(controls, that.logInfo);
					that.templateData = await that.assignControlBySpNo(controls, that.spNo,that.flowId);
					that.listLoading = false;
				});

			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				var sumPrice=this.templateData.TemplateContent.Controls.filter(item=>{return item.Property.Title[0].Text == "合计"})[0].Value
				this.templateData.TemplateContent.Controls.forEach(item=>{
					if(item.Property.Title[0].Text == "申请项目合计"){
						item.Value=sumPrice
					}
					if(item.Property.Title[0].Text == "申请项目内容"){
						item.Config.Table.Children.forEach(childItem=>{
							if(childItem.Property.Title[0].Text == "申请项目小计"){
							childItem.Value=item.Config.Table.Children.filter(item=>{return item.Property.Title[0].Text == "小计"})[0].Value
							}
							
						});
					}
				})
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				
				
				isSubmit = true;
				this.listLoading = true;
				this.sendMessageData.template=this.templateData;
				this.sendMessageData.title="核价";
				this.sendMessageData.toUser=["SC18008706"];
				this.sendMessageData.desc="申请人："+this.logInfo.EmpName;
				this.sendMessageData.url=document.location.hostname+"/projectSettlementPricing?templateId=3TmBHVUkWWzt1eWYP7Y3CPSEL4Utd8eQW16M6z3H";
				
				//提交
				sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData,1,this.logInfo.EmpName).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
